import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { StyledButton } from './styles.Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ButtonProps {
    icon?: IconDefinition;
    href?: string;
    target?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
}

export const Button: React.FC<ButtonProps> = ({ children, style, icon, href, target = '_blank', onClick }) => {
    return (
        <StyledButton href={href} target={target} onClick={onClick} style={style}>
            {icon ? <FontAwesomeIcon icon={icon} /> : null}
            {children}
        </StyledButton>
    );
};
